import { config } from '@/config'

export async function pushGTM(...args) {
  config.DEBUG && console.log(JSON.stringify(args, false, 2));
  if (!args.length) {
    return false;
  }
	if (!window.dataLayer) {
		window.dataLayer = [];
	}
  await window.dataLayer.push(...args);
}

export default pushGTM;
